export const sections = {
    home: [
        {
            id: "content-frontpage-breaking-news",
            name: "Breaking News",
        },
        {
            id: "content-frontpage-latest-news",
            name: "Latest News",
        },
        {
            id: "content-frontpage-latest-media",
            name: "Latest Media",
        },
        {
            id: "content-frontpage-highlights",
            name: "Highlights",
        },
        {
            id: "content-frontpage-top-stories",
            name: "Top Stories",
        },
        {
            id: "content-frontpage-international",
            name: "International",
        },
        {
            id: "content-frontpage-featured",
            name: "Featured",
        },
        {
            id: "content-frontpage-underscored",
            name: "Underscored",
        },
        {
            id: "content-frontpage-happening-now",
            name: "Happening Now",
        },
        {
            id: "content-frontpage-hot-topics",
            name: "Hot Topics",
        },
        {
            id: "content-frontpage-paid-content",
            name: "Paid Content",
        },
    ],
    us: [
        {
            id: "content-us-world-news",
            name: "World News",
        },
        {
            id: "content-us-around-the-nation",
            name: "Around the Nation",
        },
        {
            id: "content-us-roundup",
            name: "Roundup",
        },
        {
            id: "content-us-crime+justice",
            name: "Crime & Justice",
        },
        {
            id: "content-us-around-the-us",
            name: "Around the US",
        },
        {
            id: "content-us-latest-media",
            name: "Latest Media",
        },
        {
            id: "content-us-business",
            name: "Business",
        },
        {
            id: "content-us-underscored",
            name: "Underscored",
        },
        {
            id: "content-us-state-by-state",
            name: "State by state",
        },
        {
            id: "content-us-hot-topics",
            name: "Hot Topics",
        },
        {
            id: "content-us-paid-content",
            name: "Paid Content",
        },
    ],
    world: [
        {
            id: "content-world-global-trends",
            name: "Global trends",
        },
        {
            id: "content-world-around-the-world",
            name: "Around the world",
        },
        {
            id: "content-world-latest-media",
            name: "Latest Media",
        },
        {
            id: "content-world-today",
            name: "Today",
        },
        {
            id: "content-world-featured",
            name: "Featured",
        },
        {
            id: "content-world-international",
            name: "International",
        },
        {
            id: "content-world-global-impact",
            name: "Global Impact",
        },
        {
            id: "content-world-underscored",
            name: "Underscored",
        },
        {
            id: "content-world-global-issues",
            name: "Global Issues",
        },
        {
            id: "content-world-hot-topics",
            name: "Hot Topics",
        },
        {
            id: "content-world-paid-content",
            name: "Paid Content",
        },
    ],
    politics: [
        {
            id: "content-politics-what-really-matters",
            name: "What Really Matters",
        },
        {
            id: "content-politics-today",
            name: "Today",
        },
        {
            id: "content-politics-latest-headlines",
            name: "Latest Headlines",
        },
        {
            id: "content-politics-latest-media",
            name: "Latest Media",
        },
        {
            id: "content-politics-election",
            name: "Election",
        },
        {
            id: "content-politics-more-political-news",
            name: "More political News",
        },
        {
            id: "content-politics-underscored",
            name: "Underscored",
        },
        {
            id: "content-politics-trending",
            name: "Trending",
        },
        {
            id: "content-politics-around-the-world",
            name: "Around the World",
        },
        {
            id: "content-politics-hot-topics",
            name: "Hot Topics",
        },
        {
            id: "content-politics-paid-content",
            name: "Paid Content",
        },
    ],
    business: [
        {
            id: "content-business-latest-trends",
            name: "Latest trends",
        },
        {
            id: "content-business-market-watch",
            name: "Market Watch",
        },
        {
            id: "content-business-economy-today",
            name: "Economy Today",
        },
        {
            id: "content-business-must-read",
            name: "Must Read",
        },
        {
            id: "content-business-educational",
            name: "Educational",
        },
        {
            id: "content-business-underscored",
            name: "Underscored",
        },
        {
            id: "content-business-investing-101",
            name: "Investing 101",
        },
        {
            id: "content-business-stock-market",
            name: "Stock market",
        },
        {
            id: "content-business-impact",
            name: "Impact",
        },
        {
            id: "content-business-hot-topics",
            name: "Hot Topics",
        },
        {
            id: "content-business-paid-content",
            name: "Paid Content",
        },
    ],
    opinion: [
        {
            id: "content-opinion-a-deeper-look",
            name: "A deeper look",
        },
        {
            id: "content-opinion-top-issues",
            name: "Top Issues",
        },
        {
            id: "content-opinon-trending",
            name: "Trending",
        },
        {
            id: "content-opinion-think-about-it",
            name: "Think about it",
        },
        {
            id: "content-opinion-latest-media",
            name: "Latest Media",
        },
        {
            id: "content-opinion-in-case-you-missed-it",
            name: "In case you missed it",
        },
        {
            id: "content-opinion-environmental-issues",
            name: "Environmental Issues",
        },
        {
            id: "content-opinion-underscored",
            name: "Underscored",
        },
        {
            id: "content-opinon-what-matters-most",
            name: "What matters most",
        },
        {
            id: "content-opinion-hot-topics",
            name: "Hot Topics",
        },
        {
            id: "content-opinion-paid-content",
            name: "Paid Content",
        },
    ],
    health: [
        {
            id: "content-health-trending",
            name: "Trending",
        },
        {
            id: "content-health-latest-facts",
            name: "Latest Facts",
        },
        {
            id: "content-health-medical-breakthroughs",
            name: "Medical Breakthroughs",
        },
        {
            id: "content-health-latest-videos",
            name: "Latest Videos",
        },
        {
            id: "content-health-educational",
            name: "Educational",
        },
        {
            id: "content-health-fitness",
            name: "Fitness",
        },
        {
            id: "content-health-guides",
            name: "Guides",
        },
        {
            id: "content-health-underscored",
            name: "Underscored",
        },
        {
            id: "content-health-what-to-eat",
            name: "What to eat",
        },
        {
            id: "content-health-hot-topics",
            name: "Hot Topics",
        },
        {
            id: "content-health-paid-content",
            name: "Paid Content",
        },
    ],
};
